'use strict';

/**
 * updates wishlish icon count
 * @param {number} count - number of products in wishlist
 */
function updateCount(count) {
    if (count === 0) {
        $('.wishlist-quantity').text(0);
    } else {
        $('.wishlist-quantity').text(count);
    }
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
        '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '"><p>' + data.msg + '</p><div class="view-wishlist-cta"><a href="' + data.viewWishList.url + '">' + data.viewWishList.ctaButton + '</a></div></div>');

    updateCount(data.quantity);

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list, .wishlist-button-sm').on('click', function (e) {
            e.preventDefault();
            var url = $('.add-to-wish-list').prop('href');
            var button = $(this);
            var pid = $(this).closest('.product-detail').data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    }
};
